import { render, staticRenderFns } from "./SchemaTest.vue?vue&type=template&id=0b0fb52e&"
import script from "./SchemaTest.vue?vue&type=script&lang=js&"
export * from "./SchemaTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDate,QInput,QCheckbox,QBtn,QTooltip,QSelect,QFile} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDate,QInput,QCheckbox,QBtn,QTooltip,QSelect,QFile})
